import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { useState } from 'react';
import {isEdge, isMobileOnly} from 'react-device-detect';

const SearchBrandItemBlock = styled.div`
    width: 216px;
    position: relative;
    height: 130px;
`;

const SearchBrandItemPBlock = styled.p`
    text-align: center;
    width: 100%;
`;

const SearchBrandItemImgBlock = styled.img`
    src:${props => props.src};
    display: inline-block;
    height: 28px;   
`;

const SearchBrandItemSpanBlock = styled.span`
`;

const SearchBrandLinkContainerBlock = styled.div`
    position: absolute;
    height: 130px;
    width: 216px;
`;

const SearchBrandImageTextContainerBlock = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    text-align: center;
    display: block;
    padding: 38px 5px;
    pointer-events: none;
`;

const SearchBrandItem = ({ img_src, brndId, title, widthItem = "216px" }) => {
    //img_src = "http://sunny.mindgroup.co.kr/assets/images/dummy/dummy-img29.png";
    //title = "일룸"
    const [clientXonMouseDown, setClientXonMouseDown] = useState(null);
    const [clientYonMouseDown, setCclientYonMouseDown] = useState(null);

    const handleOnMouseDown = (e) => {
        setClientXonMouseDown(e.clientX);
        setCclientYonMouseDown(e.clientY);
        e.preventDefault() // stops weird link dragging effect
      }

    const handleOnClick = (e) => {
        e.stopPropagation()
        if (clientXonMouseDown !== e.clientX || 
            clientYonMouseDown !== e.clientY) {
          // prevent link click if the element was dragged
          e.preventDefault()
        }
      }

    return (
        <SearchBrandItemBlock className = "sbr-item" style={isMobileOnly? { width: widthItem , marginLeft:'4vw' } : { width: widthItem }}>
            <SearchBrandLinkContainerBlock>
                <Link to={"/brHome/"+brndId} onMouseDown = {handleOnMouseDown} onClick = {handleOnClick}>
                </Link>
            </SearchBrandLinkContainerBlock>
            <SearchBrandImageTextContainerBlock>
                <SearchBrandItemPBlock className = "margin_b-10">
                    <SearchBrandItemImgBlock src = {img_src} style={{ display: 'inline-block', height: '28px' }}></SearchBrandItemImgBlock>
                </SearchBrandItemPBlock>
                <SearchBrandItemSpanBlock>
                {title}
                </SearchBrandItemSpanBlock>
                
            </SearchBrandImageTextContainerBlock>
            {/* <Link to={"/brHome/"+brndId} onMouseDown = {handleOnMouseDown} onClick = {handleOnClick}>
                <SearchBrandItemPBlock className = "margin_b-10">
                    <SearchBrandItemImgBlock src = {img_src}></SearchBrandItemImgBlock>
                </SearchBrandItemPBlock>
                <SearchBrandItemSpanBlock>
                {title}
                </SearchBrandItemSpanBlock>
            </Link> */}
        </SearchBrandItemBlock>
    );
};

export default SearchBrandItem;